import { useMemo } from "react";
import { usePromotions } from "../apps/customer/hooks";

// "code:uom" -> best active offer line {offer_price, min_qty, uom, promo}
export const useOffers = () => {
  const p = usePromotions();
  return useMemo(() => {
    const m = {};
    (p.data || []).forEach((pr) => (pr.items || []).forEach((i) => {
      const k = `${i.item_code}:${i.uom}`;
      if (!m[k] || i.offer_price < m[k].offer_price) m[k] = { ...i, promo: pr };
    }));
    return m;
  }, [p.data]);
};

// offer that applies at this quantity (qty undefined = just show it)
export const offerFor = (offers, code, mode, normal, qty) => {
  const o = offers[`${code}:${mode || "box"}`];
  if (!o || o.offer_price >= normal) return null;
  return qty === undefined || qty >= o.min_qty ? o : null;
};

export const savingPct = (offer, normal) => Math.round((1 - offer / normal) * 100);

export const daysLeft = (end) => Math.max(0, Math.ceil((new Date(`${end}T23:59:59`) - new Date()) / 86400000));
